<template>
  <el-container style="height: 100%">
    <el-header
      style="
        height: 60px;
        background-color: blue;
        padding-top: 35px;
        color: white;
      "
    >
      <el-row>
        <el-col :span="8" style="text-align: left"> 《 </el-col>
        <el-col :span="8" style="text-align: center"> 预约记录 </el-col>
      </el-row>
    </el-header>
    <el-main style="flex: 1">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="name" label="姓名">
        </el-table-column>
        <el-table-column prop="date" label="日期">
        </el-table-column>
        <el-table-column label="操作" >
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleClick(scope.row)">查看详情></el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-main>
  </el-container>
</template>

<script type="text/ecmascript-6">
export default {
  name: "login",
  data() {
    return {
      tableData: [
        {
          date: "2016-05-02",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1518 弄",
        },
        {
          date: "2016-05-04",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1517 弄",
        },
        {
          date: "2016-05-01",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1519 弄",
        },
        {
          date: "2016-05-03",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1516 弄",
        },
      ],
    };
  },
  // 创建完毕状态(里面是操作)
  created() {},
  // 里面的函数只有调用才会执行
  methods: {
    nextStep() {
      this.$router.push({ path: "/appIndex/appointmentDetail" });
    },
    backToIndex() {
      this.$router.push({ path: "/appIndex" });
    },
    handleClick() {
      this.nextStep()
    }
  },
};
</script>

<style lang=less scoped>
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
}
</style>